import { useEffect, useState } from "react"
import { Edit2, Eye, Play, Plus, Search, Trash2, X } from "react-feather"
import { AdminHeader } from "../../AdminHeader"
import { AdminSidebar } from "../../../Private/MainDashboard/Sidebar/AdminSidebar"
import { Pegination } from "../../../../helper/Pegination/Pegination"
import { DeletePopupModal } from "../../../CommonPopup/DeletePopup/DeletePopupModal"
import { WebinarVideoPopup } from "./WebinarVideoPopup"
import { WebinarVideoViewPopup } from "./WebinarVideoViewPopup"
import { useAuthState } from "../../../../helper/Context/context"
import { GET_M_WebinarVideoMaster_SelectAPI, M_WebinarVideoMaster_DeleteAPI } from "../../../../helper/Redux/Slices/Admin/WebinarVideoMasterSlice/WebinarVideoMasterSlice"
import { useDispatch, useSelector } from "react-redux"
import { LogoLoader } from "../../../../helper/Loaders/LogoLoader"
import { useSearchParams } from "react-router-dom"
import { ExpandableText } from "../../../../helper/ExpandableText/ExpandableText"

export const WebinarVideo = () => {
    const [searchparams, setSearchParams] = useSearchParams()
    const userDetails = useAuthState()
    const { year, Month, Language } = userDetails
    const { UserID, token } = userDetails.user
    const dispatch = useDispatch()

    const [perPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [RowNo, setRowNo] = useState(1)
    const [currentPage, setCurrentPage] = useState(0)
    const [isOpen, setIsOpen] = useState(true)
    const [isPost, setIsPost] = useState(false)
    const [deletePopup, setDeletePopup] = useState(false)
    const [deleteData, setDeleteData] = useState(null)
    const [loader, setLoader] = useState(false)
    const initialSearchTitle = searchparams.get("Search") || ""
    const [searchTitle, setSearchTitle] = useState(initialSearchTitle)
    const [appliedSearchTitle, setAppliedSearchTitle] = useState(initialSearchTitle)

    const [webinarVideoPopup, setWebinarVideoPopup] = useState({
        show: false,
        data: "",
        screenType: "",
    })
    const [webinarVideoViewPopup, setWebinarVideoViewPopup] = useState({
        show: false,
        data: "",
    })

    const handleWebinarVideoPopup = (show, type, rowdata) => {
        setWebinarVideoPopup({
            show,
            data: rowdata || "",
            screenType: type
        })
    }

    const closeWebinarVideoPopup = () => {
        setWebinarVideoPopup({
            show: false,
            data: "",
            screenType: ""
        })
    }

    const handleWebinarVideoViewPopup = (item) => {
        setWebinarVideoViewPopup({
            show: true,
            data: item,
        })
    }

    const closeWebinarVideoViewPopup = () => {
        setWebinarVideoViewPopup({
            show: false,
            data: "",
        })
    }

    const toggle = () => {
        setIsOpen(!isOpen)
    }

    useEffect(() => {
        handleGetData(appliedSearchTitle)
    }, [year?.Label, Month?.ID, Language?.Label, isPost, appliedSearchTitle])

    const handleGetData = (searchTerm = "") => {
        const data = {
            WebinarVideoID: 0,
            SearchTerm: searchTerm,
            Flag: "Details",
            M_UserID: UserID,
            Language: Language?.Label,
            FromTop: From,
            ToTop: To,
            token: token,
        }

        dispatch(GET_M_WebinarVideoMaster_SelectAPI({ data }))
    }

    const handleSearch = () => {
        const value = searchTitle.trim()
        const nextSearchParams = new URLSearchParams(searchparams)
        if (value) nextSearchParams.set("Search", value)
        else nextSearchParams.delete("Search")
        setSearchParams(nextSearchParams, { replace: true })
        setAppliedSearchTitle(value)
    }

    const handleClearSearch = () => {
        const nextSearchParams = new URLSearchParams(searchparams)
        nextSearchParams.delete("Search")
        setSearchParams(nextSearchParams, { replace: true })
        setSearchTitle("")
        setAppliedSearchTitle("")
    }

    const { isLoading, TableData } = useSelector((state) => state.GET_M_WebinarVideoMaster_SelectData)

    const handleIsPost = () => {
        setIsPost((value) => !value)
        setDeletePopup(false)
        setDeleteData(null)
    }

    const handleDeleteClick = () => {
        setLoader(true)
        const data = {
            WebinarVideoID: deleteData?.webinarVideoID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            setloader: setLoader,
        }
        dispatch(M_WebinarVideoMaster_DeleteAPI({ data }))
    }

    const handleDelete = (item) => {
        setDeleteData(item)
        setDeletePopup(true)
    }

    const handleDeleteClose = () => {
        if (!loader) {
            setDeletePopup(false)
            setDeleteData(null)
        }
    }

    return (
        <>
            {isLoading && <LogoLoader />}
            <div className="container-scroller ms-2 custom" style={{ backgroundColor: "#ececec" }}>
                <div className="row background_main_all px-1">
                    <AdminHeader toggle={toggle} isopen={isOpen} />

                    <div className="container-fluid page-body-wrapper mx-0">
                        <AdminSidebar isopen={isOpen} setIsOpen={setIsOpen} active="dashboard" />

                        <div
                            className="main-panel"
                            style={{ width: isOpen ? "" : "calc(100% - 1px)", marginLeft: isOpen ? "" : "1px" }}
                        >
                            <div className="content-wrapper px-3">
                                <div className="col-12">
                                    <div className="shadows bg-white row rounded p-3">
                                        <div className="card shadow-sm py-2 mb-3">
                                            <div className="d-flex justify-content-between align-items-center col-12 pt-0 border-bottom pb-2 mb-2">
                                                <h5 className="fw-bold mb-0 me-2 screen-title">Webinar Video</h5>
                                                <button type="button" className="btn btn-primary text-nowrap" onClick={() => handleWebinarVideoPopup(true, "add", "")}>
                                                    <Plus size={18} className="me-1" />
                                                    Add
                                                </button>
                                            </div>

                                            <div className="d-flex flex-wrap align-items-center justify-content-start gap-3 pb-2">
                                                <div className="d-flex align-items-center gap-2">
                                                    <label htmlFor="webinarTitle" className="form-label mb-0 text-nowrap">Title :</label>
                                                    <input id="webinarTitle" type="text" className="form-control" value={searchTitle} onChange={(event) => setSearchTitle(event.target.value)} />
                                                </div>
                                                <button type="button" className="btn btn-secondary text-nowrap" onClick={handleSearch}>
                                                    <Search size={18} className="me-1" />
                                                    Search
                                                </button>
                                                <button type="button" className="btn btn-danger text-nowrap" onClick={handleClearSearch}>
                                                    <X size={18} className="me-1" />
                                                    Clear
                                                </button>
                                            </div>
                                        </div>

                                        <div className="table-responsive px-0">
                                            <table id="customers" className="seminar-video-table">
                                                <thead>
                                                    <tr>
                                                        <th>Sr. No.</th>
                                                        <th>Title Name</th>
                                                        <th>Sub Title Name</th>
                                                        <th>Description</th>
                                                        <th>Purchased Users</th>
                                                        <th>Amount</th>
                                                        {/* <th>Videos</th> */}
                                                        <th className="seminar-action-column">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {TableData && TableData.length > 0 ? TableData.map((item) => (
                                                        <tr key={item.webinarVideoID}>
                                                            <td align="center" className="cust-min-width-70">{item.rowNum}</td>
                                                            <td align="left" className="text-capitalize cust-min-width-180 text-start">
                                                                <ExpandableText value={item.titleName} />
                                                            </td>
                                                            <td align="left" className="text-capitalize cust-min-width-180 text-start">
                                                                <ExpandableText value={item.subTitleName} />
                                                            </td>
                                                            <td align="left" className="cust-min-width-180 text-start">
                                                                <ExpandableText value={item.description} />
                                                            </td>
                                                            <td className="text-start cust-min-width-180">{item.Total_PurchasedUsers ? item.Total_PurchasedUsers : "-"}</td>
                                                            <td align="right" className="text-right cust-min-width-180">₹{item.video_PurchaseAmount ? item.video_PurchaseAmount : "-"}</td>

                                                            {/* <td align="center" className="cust-min-width-180 text-center">
                                                                {!item.video?.length ? "-" : item.video.map((video, index) => (
                                                                    <div className="seminar-video-table-row cust-min-width-180" key={index}>
                                                                        <img src={video.thumbnailUrl} alt={`${item.titleName} video ${index + 1}`} className="seminar-table-photo" />
                                                                        <button type="button" className="seminar-video-file-link" onClick={() => window.open(video.videoUrl)}>
                                                                            <Play size={12} fill="currentColor" />
                                                                            {video.videoUrl.split("/").pop().split("?")[0]}
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </td> */}
                                                            <td align="center" className="seminar-action-column cust-min-width-180">
                                                                <div className="d-inline-flex align-items-center justify-content-center gap-1">
                                                                    <button type="button" className="btn btn-success seminar-action-btn d-inline-flex align-items-center justify-content-center" aria-label={`View ${item.titleName}`} title="View webinar video" onClick={() => handleWebinarVideoViewPopup(item)}>
                                                                        <Eye size={15} />
                                                                    </button>
                                                                    <button type="button" className="btn btn-primary seminar-action-btn d-inline-flex align-items-center justify-content-center" aria-label={`Edit ${item.titleName}`} title="Update webinar video" onClick={() => handleWebinarVideoPopup(true, "edit", item)}>
                                                                        <Edit2 size={15} />
                                                                    </button>
                                                                    <button type="button" className="btn btn-danger seminar-action-btn d-inline-flex align-items-center justify-content-center" aria-label={`Delete ${item.titleName}`} title="Delete webinar video" onClick={() => handleDelete(item)}>
                                                                        <Trash2 size={15} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan={5}>No Data Found ...</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="col-12 pt-3 px-0">
                                            {TableData && TableData.length > 0 && (
                                                <Pegination
                                                    PerPageCount={perPageCount}
                                                    TotalCount={TableData[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setRowNo}
                                                    CurrentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {webinarVideoPopup.show && (
                <WebinarVideoPopup
                    WebinarVideoData={webinarVideoPopup}
                    cancelbtn={closeWebinarVideoPopup}
                    setIsPost={setIsPost}
                    IsPost={isPost}
                />
            )}
            {webinarVideoViewPopup.show && (
                <WebinarVideoViewPopup
                    WebinarVideoData={webinarVideoViewPopup}
                    cancelbtn={closeWebinarVideoViewPopup}
                />
            )}
            {deletePopup && (
                <DeletePopupModal
                    confirmBtnCallBack={handleDeleteClick}
                    deleteRecord={deleteData}
                    loader={loader}
                    message="Are you sure, you want to delete this webinar video?"
                    cancelBtnCallBack={handleDeleteClose}
                    heading="Delete"
                />
            )}
        </>
    )
}

